import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import Name from '../../components/Name/Name'
import Badges from '../../components/Badges/Badges'
import Youreko from '../../components/Youreko/Youreko'
import ReviewsFlag from '../../components/ReviewsFlag/ReviewsFlag'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'
import EnergyLabelBadge from '@/components/EnergyLabelBadge/EnergyLabelBadge'

const DefaultHeadingSection = ({ energyPDF, name, catNumber, badgesOptions, reviewsFlagOptions }) => {
  const { energyValue } = badgesOptions
  const { PDP_V2_FLAG } = useFeatureFlagContext()

  return (
    <>
      <ErrorBoundary>
        <Badges {...badgesOptions} energyPDF={energyPDF} />
        {!PDP_V2_FLAG && <Youreko />}
      </ErrorBoundary>
      <ErrorBoundary>
        <Name productName={name} catNumber={catNumber} />
      </ErrorBoundary>
      <ErrorBoundary>
        <div className={`ds-flex ds-justify-between ds-flex-wrap ${!energyValue && 'ds-mb-1'}`}>
          <ReviewsFlag {...reviewsFlagOptions} />
          {energyValue && PDP_V2_FLAG && (
            <EnergyLabelBadge ratingType={energyValue} customLinkName='Info sheet' linkUrl={energyPDF} />
          )}
        </div>
      </ErrorBoundary>
      <ErrorBoundary>{PDP_V2_FLAG && <Youreko />}</ErrorBoundary>
    </>
  )
}

DefaultHeadingSection.propTypes = {
  name: PropTypes.string,
  badgesOptions: PropTypes.object,
  reviewsFlagOptions: PropTypes.object,
  energyPDF: PropTypes.string,
  catNumber: PropTypes.string
}

export default DefaultHeadingSection
